module.exports = __webpack_public_path__ + "img/compliance-filter.e63fd31d.svg";